export default __webpack_public_path__ + "static/school_filming-b3e9a708d9e1556303ae88ceffcc017d.jpg";